/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Status_RepliedInputs */

const en_settings_tickets_status_replied = /** @type {(inputs: Settings_Tickets_Status_RepliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Progress`)
};

/**
* | output |
* | --- |
* | "In Progress" |
*
* @param {Settings_Tickets_Status_RepliedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_status_replied = /** @type {((inputs?: Settings_Tickets_Status_RepliedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Status_RepliedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_status_replied(inputs)
});
export { settings_tickets_status_replied as "settings.tickets.status_replied" }